import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/flights/orders.ts
import { Exception } from "@wbk/logger";
var getFlightsOrders = (_0) => __async(void 0, [_0], function* ({ lang }) {
  try {
    const data = yield fetchClient({
      url: `/flights?lang=${lang}`,
      version: "v1"
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getFlightsOrdersException"
    });
  }
});
var getFlightOrder = (_0) => __async(void 0, [_0], function* ({ lang, id }) {
  try {
    const data = yield fetchClient({
      url: `/flights/${id}?lang=${lang}`,
      version: "v1"
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getFlightOrderException"
    });
  }
});

export {
  getFlightsOrders,
  getFlightOrder
};
//# sourceMappingURL=chunk-FKYUOZ3E.mjs.map